import _objectSpread from "/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export var LOCAL_STORAGE_KEY = 'DI_CCDP';
export var errorPrefix = 'DI CCDP :: Failed to get from local storage;';
/**
 * Abstraction to set data on the `LOCAL_STORAGE_KEY` key in local storage.
 */

export function getStorage() {
  try {
    var rawData = window.localStorage.getItem(LOCAL_STORAGE_KEY);

    if (rawData === null) {
      return {};
    }

    return JSON.parse(rawData);
  } catch (err) {
    console.error("".concat(errorPrefix, " ").concat(err));
    return {};
  }
}
/**
 * Abstraction to patch data on the `LOCAL_STORAGE_KEY` key in local storage.
 * Will only overwrite the existing storage for only the keys provided on the
 * parameter.
 */

export function patchStorage(data) {
  try {
    var currentStorage = getStorage();

    var newData = _objectSpread(_objectSpread({}, currentStorage), data);

    var stringifiedData = JSON.stringify(newData);
    window.localStorage.setItem(LOCAL_STORAGE_KEY, stringifiedData);
  } catch (err) {
    console.error("".concat(errorPrefix, " ").concat(err));
  }
}